<template>
  <!-- 首页 -->
  <div class="my">
    <div class="banner">
      <!-- video 第一个是视频 -->
      <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(image, index) in bannerList" :key="index">
          <img
            :src="image.imagePath | qiniuImageView(1, 710, 400)"
            @click="toUrl(image.linkUrl)"
          />

          <img
            class="video-btn"
            @click="ckVideo(image.video)"
            v-if="!isEmpty(image.video)"
            src="../../assets/images/video.png"
          />
        </van-swipe-item>
      </van-swipe> -->
      <!-- yyh5 start -->
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(image,index) in swipeList" :key="index">
          <img
            :src="image.imagePath | qiniuImageView(1, 710, 400)"
            @click="toUrl(image.linkUrl)"
          />
          <img
            class="video-btn"
            @click="ckVideo(image.videoPath)"
            v-if="!isEmpty(image.videoPath)"
            src="../../assets/images/video.png"
          />
        </van-swipe-item>
      </van-swipe>
      <!-- yyh5 end -->
    </div>

    <div class="mine-box">
      <!-- 后期图片上传云端后用 注释开始 -->
      <div v-for="(item, index) in bannerList" :key="index">
         <div
          class="mine-item"
          @click="toMine(item.type -1)"
         >
          <img :src="item.imagePath | qiniuImageView(1, 710, 224)"/>
        </div>
      </div>
      <!-- <img v-if="bannerList.length == 0"  src="https://img01.yzcdn.cn/vant/cat.jpeg" alt=""> -->
      
      <!-- 注释结束 -->
      <!-- 静态开始 -->
      <!-- <div 
        class="mine-item"
        @click="toMine(0)"
      >
        <img src="../../assets/images/bar1.png" />
      </div>
      <div
        class="mine-item"
        @click="toMine(1)"
      >
        <img src="../../assets/images/bar2.png" />
      </div>
      <div
        class="mine-item"
        @click="toMine(2)"
      >
        <img src="../../assets/images/bar3.png" />
      </div>
      <div
        class="mine-item"
        @click="toMine(3)"
      >
        <img src="../../assets/images/bar4.png" />
      </div> -->
      <!-- 静态结束 -->
    </div>
    <!-- <div class="list-box" v-if="!isEmpty(homeList)">
           // type1
            <div class="list" v-for="item in homeList">
                <p class="title mt-10">
                    <span class="f-fs16 f-fc1 f-fwb">{{ item.name }}</span>
                    <span class="f-fc12 f-fs12 ml-10">{{ item.serviceDesc }}</span>
                </p>
                <div class="list-type1" data-flex="cross:center" v-if="item.id == 1">
                    <div data-flex="dir:top main:center cross:center" v-for="ch in item.children"
                        @click="toUrl(ch.linkUrl)">
                        <img :src="ch.mainImage | qiniuImageView(1, 90, 90)" />
                        <p class="f-fs12 f-fwb f-fc1 mt-10">{{ ch.name }}</p>
                    </div>
                </div>

                <div class="list-type2" data-flex="cross:center" v-if="item.id == 2">
                    <div data-flex="dir:top main:center cross:center" v-for="ch in item.children"
                        @click="toUrl(ch.linkUrl)">
                        <img :src="ch.mainImage | qiniuImageView(1, 330, 314)" />
                    </div>
                </div>

                <div class="list-type3" data-flex="cross:center" v-if="item.id == 3">
                    <div data-flex="dir:top main:center cross:center">
                        <img v-for="(ch, i) in item.children" :key="i" v-if="i == 0" @click="toUrl(ch.linkUrl)"
                            :src="ch.mainImage | qiniuImageView(1, 330, 464)" />
                    </div>
                    <div data-flex="dir:top main:top cross:center">
                        <img v-for="(ch, i) in item.children" :key="i" v-if="i == 1" @click="toUrl(ch.linkUrl)"
                            :src="ch.mainImage | qiniuImageView(1, 330, 217)" />
                        <img class="mt-30" v-for="(ch, i) in item.children" :key="i" v-if="i == 2"
                            @click="toUrl(ch.linkUrl)" :src="ch.mainImage | qiniuImageView(1, 330, 217)" />
                    </div>
                </div>

            </div>
        </div> -->

    <!-- <div class="foot-box">
            <div>
                <p class="title mt-10">
                    <span class="f-fs16 f-fc1 f-fwb">联系我们</span>
                </p>
                <div class="foot-info">
                    <a :href="`tel:${kfInfo.tel}`" class="f-fc1">
                        <p data-flex="cross:center">热线电话：{{ kfInfo.tel }}
                            <img src="../../assets/images/h-01.png" />
                        </p>
                    </a>
                    <p>客服邮箱：{{ kfInfo.mail }}</p>
                </div>
            </div>
            <div>
                <p class="title mt-10">
                    <span class="f-fs16 f-fc1 f-fwb">服务时间</span>
                </p>
                <div class="foot-info">
                    <p data-flex="cross:center" v-html="kfInfo.time.replace(/\n/g, '<br/>')"></p>
                </div>
            </div>
        </div> -->

    <!-- <div class="kefu" @click="toUrl(kfInfo.kfLink)">
            <img src="../../assets/images/kefu.png" alt="">
        </div> -->

        <van-tabbar v-model="active" style="position: fixed; bottom: 0;">
            <van-tabbar v-model="active" active-color="#FD4A46">
                <van-tabbar-item @click="tabsTo(1)">
                    <span>预约</span>
                    <template #icon="props">
                        <img v-if="props.active" src="../../assets/images/ph-11.png" alt="">
                        <img v-else src="../../assets/images/t-01.png" alt="">
                    </template>
                </van-tabbar-item>
                <van-tabbar-item @click="tabsTo(2)">
                    <span>申报</span>
                    <template #icon="props">
                        <img v-if="props.active" src="../../assets/images/sq1.png" alt="">
                        <img v-else src="../../assets/images/sq0.png" alt="">
                    </template>
                </van-tabbar-item>
                <van-tabbar-item icon="search" @click="tabsTo(3)">
                    <span>我的</span>
                    <template #icon="props">
                        <img v-if="props.active" src="../../assets/images/my.png" alt="">
                        <img v-else src="../../assets/images/t-02.png" alt="">
                    </template>
                </van-tabbar-item>
            </van-tabbar>
        </van-tabbar>

    <!-- <van-popup v-model:show="isMobileNumber">
      <div class="popup1">
        <p class="f-fc1 f-fwb">绑定手机了解更多服务信息</p>
        <div class="inp mt-25" data-flex="cross:center">
          <van-field
            class="f-fs12"
            v-model="formData.mobileNumber"
            type="tel"
            placeholder="请输入手机号"
          />
          <p @click="sendMCode()">{{ btn1Text }}</p>
        </div>
        <div class="inp mt-40">
          <van-field
            class="f-fs12"
            v-model="formData.mcode"
            type="tel"
            placeholder="请输入验证码"
          />
        </div>
        <van-button class="mt-30" type="primary" @click="bindMobile"
          >立即绑定</van-button
        >
      </div>
      <div class="mobileHide" @click="isMobileNumber = false">
        <img class="" src="../../assets/images/rem.png" />
      </div>
    </van-popup> -->

    <!-- <van-popup v-model:show="showVideo"> -->
    <van-popup v-model="showVideo">
      <div class="popup2">
        <video
          v-if="showVideo"
          controls
          :src="videoData"
          :poster="videoData + '?x-oss-process=video/snapshot,t_1000,m_fast'"
        ></video>
      </div>
      <div class="mobileHide" @click="showVideo = false">
        <img class="" src="../../assets/images/rem.png" />
      </div>
    </van-popup>

  </div>
</template>

<script>
import mix1 from "@/mixins/page";
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from "@/utils/ui";
import { delayAsync } from "@/utils/common";
import {
  Field,
  Popup,
  Button,
  NumberKeyboard,
  Swipe,
  SwipeItem,
  Lazyload,
  Card,
  Tabbar,
  TabbarItem,
  List,
  Toast,
} from "vant";
import {
  localStorageGet,
  localStorageSet,
  localStorageRemove
} from "@/utils/storage";
import { cacheKeys } from "../../config/CacheKeys";
import MgPopup from "@/components/common/mg-popup";
import { userInfo } from "os";

import wxShare from "@/utils/wxShare";
import { config } from 'process';

const mineUrls = {
  0: "/home/application", //我要申请
  1: "/declare/index", //我要申报(预约)
  2: "/my/qrcode",
  3: "/ercode/hexiao"
};
export default {
  mixins: [mix1],
  name: "HomeIndex",
  components: {
    // MgPopup,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    NumberKeyboard,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Lazyload.name]: Lazyload,
    [Card.name]: Card,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [List.name]: List, 
  },
  data() {
    return {
      active: 0,
      homeList: [],
      kfInfo: {
        tel: "",
        mail: "",
        time: ""
      },
      icon: {
        active: "https://unpkg.com/@vant/assets/user-active.png",
        inactive: "https://unpkg.com/@vant/assets/user-inactive.png"
      },
      kb1: {
        show: false
      },
      isMobileNumber: false,
      showVideo: false,
      videoData: "",
      btn1Text: "获取验证码",
      formData: {
        mobileNumber: "",
        mcode: ""
      },
      bannerList: [],
      list: [],
      tel: "",
      loading: false,
      finished: false,
      profile: {},
      swipeList:[],
      loginId:"",
      infodata:{
        declarant: 0, //申报人 1:是
        staff: 0, //工作人员 1:是
        quota: 0, //配额数
        usedCount: 0, //已用数量
        usableCount: 0 //可用数量
      },
      proarray:[],
      sqrData:{},//是否已经申请过，如是，有数据
      havesqrData:false,//是否申请过成为申报人
      wtgData:{},//是否已经预约过且未通过，如是，有数据
      havewtgData:false,//是否有未通过预约
    };
  },
  computed: {},
  methods: {
    // fromMiniProgram(){
    //   let user_id = this.$route.query['user_id'];
    //   console.log("user_id:",user_id);
    // },
    // 获取用户信息
    async getUserInfo(){
        uiShowLoading();
        const promise = this.apiGet('my.userInfo')
        let apiResult = null
        try {
            apiResult = await promise
            this.getBanner();
        } catch (ex) {
            apiResult = null
            alert("获取用户信息失败，无法确认角色权限，请联系管理员")
        }
        if (this.isEmpty(apiResult)) {
            return
        }
        this.infodata = apiResult.obj
        console.log("this.infodata=>",this.infodata)
    },

    // 是否成为申请人的数据getSqData
    async getSqData(){
        uiShowLoading();
        const promise = this.apiGet("declaration.postForm");
        let apiResult = null;
        try {
            apiResult = await promise;
        } catch (ex) {
            apiResult = null;
        }
        if (this.isEmpty(apiResult)) {
            return;
        }
        console.log("getSqData:",apiResult);
        if(apiResult.obj.id){
          this.sqrData = apiResult.obj;
        }
        console.log("是否申请人提交过数据:",this.sqrData);
        if(this.sqrData.id){
          console.log("this.sqrData.id",this.sqrData.id);
          this.havesqrData = true;
        }
        uiHideLoading();
        this.getyy();
    },

    // 是否有未通过的预约
    async getyy(){
      uiShowLoading();
        const promise = this.apiGet("yy.state");
        let apiResult = null;
        try {
            apiResult = await promise;
        } catch (ex) {
            apiResult = null;
        }
        if (this.isEmpty(apiResult)) {
            return;
        }
        console.log("getyy:",apiResult);
        if(apiResult.obj.id){
          this.wtgData = apiResult.obj;
        }
        if(this.wtgData.id){
          console.log("this.wtgData.id",this.wtgData.id);
          this.havewtgData = true;
        }
        console.log("是否有未通过的预约:",this.wtgData);
        uiHideLoading();
    },

    getQueryParam(param) {
        const regExp = new RegExp(`[\\?&]${param}=([^&#]*)`);
        const match = window.location.search.match(regExp);
        return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : null;
    },

    // 后端要的登录
    async login(){
      let id = this.loginId;
      const promise = this.apiPost("denglu",{user_id:id});
      let apiResult = null
      try {
        apiResult = await promise;
      } catch (ex) {
        console.log("ex：",ex);
        apiResult = null;
      }
      console.log("登录返回：",apiResult);
      if (apiResult.obj) {
            let jwts = localStorageGet("jwt"); 
            console.log("未设置前的jwt：",jwts);
            localStorageSet("jwt", apiResult.obj.jwt)
            this.getUserInfo();
        }else{
          uiAlert("登录失败，请联系客服");
        }
        console.log("登录后设置jwt：",localStorageGet("jwt"));
    },

    onLoad() {
      return;
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },

    loadData() {
      Promise.all([
        this.apiGet("homepage.slideImages"),
        // this.apiGet("homepageVajraDistrict.list"),
        // this.apiGet("kf.info"),
        // this.apiGet("fans.profile")
      ])
        .then(results => {
          this.swipeList = results[0].list;

          // this.swipeList[0].videoPath = 'https://www.w3school.com.cn/example/html5/mov_bbb.mp4'
          
          console.log("this.swipeList=>",this.swipeList);

          // this.homeServicesList = results[0].list;

          // let list = results[0].list.map((it, i) => {
          //   let children = [];

          //   results[1].list.find((ch, s) => {
          //     if (it.id == ch.type) {
          //       children.push(ch);
          //     }
          //   });

          //   let item = Object.assign(it, { children });

          //   return item;
          // });
          // this.homeList = list;

          // let kfInfo = {
          //   tel: "",
          //   mail: "",
          //   time: "",
          //   kfLink: ""
          // };
          // results[2].list.find(it => {
          //   if (it.configKey == "kf.link") {
          //     kfInfo.kfLink = it.configValue;
          //     localStorageSet("kfLink", it.configValue);
          //   }
          //   if (it.configKey == "kf.telephone") {
          //     kfInfo.tel = it.configValue;
          //   }
          //   if (it.configKey == "kf.email") {
          //     kfInfo.mail = it.configValue;
          //   }
          //   if (it.configKey == "kf.serviceTime") {
          //     kfInfo.time = it.configValue;
          //   }
          // });
          // this.kfInfo = kfInfo;
          // this.profile = results[3].obj;
          // if (this.isEmpty(results[3].obj.mobileNumber)) {
          //   this.isMobileNumber = true;
          // } else {
          //   this.isMobileNumber = false;
          // }
          console.log(results);
        })
        .catch((err)=>{
          console.log(err);
        });
    },
    toUrl(url) {
      // 轮播图跳地址
      if (!this.isEmpty(url)) {
        window.location.href = url;
      }
    },
    toMine(type) {
      console.log(type);
      if(type == 0){
        if(this.havesqrData){
          console.log("走0了");
          this.$router.push('/home/AddOk');
          return;
        }

        if(!this.havesqrData){
          console.log("走1了");
          this.$router.push(mineUrls[type]);
          return;
        }

      }else if(type == 1){
        if(this.havewtgData){
          console.log("走0了");
          this.$router.push('/declare/declareOk');
          return;
        }

        if(!this.havewtgData){
          console.log("走1了");
          this.$router.push(mineUrls[type]);
          return;
        } 

      }else{
        this.$router.push(mineUrls[type]);
      }
      
    },
    ckVideo(val) {
      this.showVideo = true;
      this.videoData = this.qiniuResource(val);
    },

    changeban(){
      let bannerList2 = [];
      if(this.infodata.declarant == 0){
        bannerList2.push(this.proarray[0])
      }

      if(this.infodata.declarant == 1){
        bannerList2.push(this.proarray[1])
      }

      bannerList2.push(this.proarray[2])

      if(this.infodata.staff == 1){
        bannerList2.push(this.proarray[3])
      }
      
      console.log("bannerList2",bannerList2);
      this.bannerList = bannerList2;
      uiHideLoading();

      this.getSqData();
    },

    getBanner() {
      let data = {
        type: 1
    };
      let data2 = {
        type: 2
    };
      let data3 = {
        type: 3
    };
      let data4 = {
        type: 4
    };
    Promise.all([
      this.apiGet("homepage.banner",data),
      this.apiGet("homepage.banner",data2),
      this.apiGet("homepage.banner",data3),
      this.apiGet("homepage.banner",data4)
      ]).then((results)=>{
        this.proarray = results.map((it,index)=>{
          it.obj['type'] = index+1;
          console.log("it:",it);
          return it.obj
        })
        console.log("this.proarray",this.proarray);
        this.changeban();
      }).catch((err)=>{
        console.log(err);
      })
    },

    tabsTo(type) {
      if (type == 1) {
        this.$router.push("/");
      } else if (type == 2) {
        if(this.havewtgData){
          this.$router.push("/declare/declareOk");
        }
        else if(!this.havewtgData){
          if(!this.havesqrData){
          this.$router.push("/home/application");
          }else{
            if(this.infodata.declarant == 1){
              this.$router.push("/declare/index");
            }else if(this.infodata.declarant == 0){
              this.$router.push("/home/addOk");
            }else if(this.infodata.declarant == 2){
                Toast('申报功能被冻结');
            }
          }
        }
      } else {
        this.$router.push("/my/index");
      }
    },

    async sendMCode() {
      if (this.isCountdowning) {
        return;
      }

      const mobile = this.formData.mobileNumber;

      if (!mobile) {
        uiAlert("请填写手机号码");
        return;
      }

      uiShowLoading();
      await delayAsync(500);
      let apiResult = null;

      try {
        apiResult = await this.apiPost("fans.sendcode", {
          mobileNumber: mobile
        });
      } catch (ex) {
        apiResult = null;
      }

      uiHideLoading();

      if (this.isEmpty(apiResult)) {
        return;
      }

      let secs = 60;
      this.btn1Text = secs;
      this.isCountdowning = true;

      const t1 = setInterval(() => {
        if (secs < 1) {
          clearInterval(t1);
          this.btn1Text = "获取";
          this.isCountdowning = false;
          return;
        }

        secs--;
        this.btn1Text = secs;
      }, 1000);
    },
    async bindMobile() {
      let formData = this.formData;
      const promise = this.apiPost("bindMobile", formData);

      let apiResult = null;

      try {
        apiResult = await promise;
      } catch (ex) {
        apiResult = null;
      }
      console.log(apiResult);

      if (apiResult.errno != 0) {
        Toast(apiResult.error);
        return;
      }
      Toast("绑定成功");
      this.isMobileNumber = false;

      // uiAlert('绑定成功', () => this.$router.go(-1))
    },
    async getWxShareInfo() {
      const promise = this.apiGet("fx.jsapi", {
        jsapiUrl: window.location.href
      });

      let apiResult = null;

      try {
        apiResult = await promise;
      } catch (ex) {
        apiResult = null;
      }

      if (this.hasException(apiResult)) {
        return;
      }

      const data = {
        debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: apiResult.obj.appId, // 必填，公众号的唯一标识
        timestamp: apiResult.obj.timestamp, // 必填，生成签名的时间戳
        nonceStr: apiResult.obj.noncestr, // 必填，生成签名的随机串
        signature: apiResult.obj.signature // 必填，签名
        // jsApiList: "jsApiList", // 必填，需要使用的JS接口列表
      };
      const dataForWeixin = {
        title: "大狮汇",
        desc: "大狮汇-中国最大的企业家户外社交活动报名平台",
        link: window.location.href,
        imgUrl:
          "http://cdn.meiguonet.com/zhongchuang/pq/dp/ahkuwjkkdkmvadlwsglperwrdpgumxcr.jpg"
      };
      wxShare.getJSSDK(data, dataForWeixin);
      // this.del = apiResult.obj
    },

  },
  mounted() {},
  created() {
    // this.fromMiniProgram();
    let user_id2 = this.getQueryParam('user_id');
    this.loginId = user_id2;
    console.log("user_id2:",user_id2);

    let jwts = localStorageGet("jwt"); 

    if(user_id2 != "" && user_id2 != undefined && user_id2 != null){
      this.login();
    }else if(jwts && jwts.token){
      console.log("进入2");
      this.getUserInfo();
    }else{
      alert("请先登录后使用");
    }

    

    let srcMemberId = this.$route.query.userId;
    // this.userInfo()
    // this.getBanner();
    // this.search()
    // this.getWxShareInfo()
    this.loadData();

    localStorageRemove("qdSrcMemberId");

    if (!this.isEmpty(srcMemberId)) {
      localStorageSet("qdSrcMemberId", srcMemberId);
    }
  }
};
</script>

<!-- <style lang="less" scoped>
.van-tabbar-item--active {
  color: #205cff;
}

.van-tabbar--fixed {
  height: 100px;
}

.van-hairline--top-bottom {
  padding: 0 50px;
  box-sizing: border-box;
}

.van-swipe__indicator {
  width: 10px;
  height: 10px;
}

.list {
  .van-card {
    padding-bottom: 30px;
    background: #fff;

    .van-card__thumb {
      width: 300px;
      height: 150px;
    }

    .van-card__content {
      .van-card__title {
        font-size: 14px;
        color: #333;
        line-height: 24px;
      }

      .van-card__price {
        font-size: 16px;
        line-height: 14px;
        color: #e84115;
      }
    }
  }
}
</style> -->




<style lang="less" scoped>
.postdiv{
  border: 1px solid red;
  width: 750px;
  height: 100px;
}





// .kefu {
//   position: fixed;
//   bottom: 200px;
//   right: 20px;
//   background: none;
//   width: 138px;
//   height: 131px;

//   img {
//     width: 138px;
//     height: 131px;
//   }
// }

.my {
  padding-bottom: 120px;
  .banner {
    padding: 20px;
    box-sizing: border-box;
    padding-bottom: 20px;
    > div {
      background: #edf0f4;
    }
  }

  .mine-box {
    padding: 0px 20px 0px;
    .mine-item {
      padding-bottom: 15px;
      cursor: grabbing;
      background: #edf0f4;
      &:last-child {
        padding-bottom: 0px;
      }
      img {
        width: 702px;
        height: 224px;
        border-radius: 15px;
        background: #edf0f4;
      }
    }
  }
  .my-swipe {
    width: 710px;
    height: 400px;
    position: relative;
  
    img {
      width: 710px;
      height: 400px;
      border-radius: 15px;
    }

    .video-btn {
      width: 80px;
      height: 80px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -40px;
      margin-left: -40px;
      opacity: 0.8;
    }
  }

  .my-swipe .van-swipe-item {
    color: #ccc;
    font-size: 21px;
    line-height: 150px;
    text-align: center;
  }

  .list-box {
    .list {
      .title {
        padding: 30px;
        box-sizing: border-box;
      }
    }

    .list-type1 {
      width: 690px;
      margin: 0 auto;
      background: #fff;
      border-radius: 10px;
      padding: 30px 0;
      box-sizing: border-box;

      > div {
        width: 20%;

        img {
          width: 90px;
          height: 90px;
        }
      }
    }

    .list-type2 {
      padding: 0 15px;

      > div {
        padding: 0 15px;

        img {
          width: 330px;
          height: 314px;
        }
      }
    }

    .list-type3 {
      padding: 0 15px;

      > div {
        padding: 0 15px;

        img {
          width: 330px;
          height: 217px;
        }
      }

      > div:nth-child(1) {
        padding: 0 15px;

        img {
          width: 330px;
          height: 464px;
        }
      }

      > div:nth-child(2) {
        height: 464px;
      }
    }
  }

  .foot-box {
    > div {
      .title {
        padding: 30px;
        box-sizing: border-box;
      }

      .foot-info {
        background: #edf0f4;
        border-radius: 10px;
        width: 690px;
        margin: 0 auto;
        padding: 25px;
        box-sizing: border-box;

        p {
          line-height: 40px;
          font-size: 14px;

          img {
            width: 40px;
            height: 40px;
            border-radius: 100px;
            margin-left: 10px;
          }
        }
      }
    }
  }

  .van-popup {
    background: none;
  }

  .popup1 {
    width: 477px;
    height: 539px;
    text-align: center;
    border-radius: 10px;
    background: url("../../assets/images/i-01.png") no-repeat;
    background-size: cover;
    padding-top: 180px;
    box-sizing: border-box;
    position: relative;

    .inp {
      border: solid 1px #bfbfbf;
      width: 375px;
      margin: 0 auto;
      border-radius: 10px;

      .van-cell {
        padding: 10px;
      }

      .van-cell::after {
        border: none;
      }

      p {
        font-size: 12px;
        color: #609ffa;
        width: 200px;
      }
    }

    button {
      width: 220px;
      height: 58px;
      border-radius: 200px;
      background: #205cff;
      border-color: #205cff;
    }
  }

  .popup2 {
    padding: 30px;
    box-sizing: border-box;
    background: #fff;
    width: 600px;
    height: 400px;
    border-radius: 20px;
    text-align: center;

    video {
      width: 540px;
      height: 340px;
    }
  }

  .mobileHide {
    margin: 50px auto;
    text-align: center;

    img {
      width: 50px;
      height: 50px;
    }
  }
}
</style>
